// This file is auto-generated by @hey-api/openapi-ts

import type { Options as ClientOptions, TDataShape, Client } from './client';
import type { ListDocumentsDocumentsGetData, ListDocumentsDocumentsGetResponses, ListDocumentsDocumentsGetErrors, GetDocumentDocumentsKeyGetData, GetDocumentDocumentsKeyGetResponses, GetDocumentDocumentsKeyGetErrors, GetDocumentSnapshotDocumentsKeySnapshotGetData, GetDocumentSnapshotDocumentsKeySnapshotGetResponses, GetDocumentSnapshotDocumentsKeySnapshotGetErrors, GetDocumentPdfUrlDocumentsKeyPdfGetData, GetDocumentPdfUrlDocumentsKeyPdfGetResponses, GetDocumentPdfUrlDocumentsKeyPdfGetErrors, GetDocumentAuditTrailDocumentsKeyAuditTrailGetData, GetDocumentAuditTrailDocumentsKeyAuditTrailGetResponses, GetDocumentAuditTrailDocumentsKeyAuditTrailGetErrors, AssignReviewerToDocumentDocumentsKeyReviewerPostData, AssignReviewerToDocumentDocumentsKeyReviewerPostResponses, AssignReviewerToDocumentDocumentsKeyReviewerPostErrors, GetDocumentClusterInfoDocumentsKeyClusterInfoGetData, GetDocumentClusterInfoDocumentsKeyClusterInfoGetResponses, GetDocumentClusterInfoDocumentsKeyClusterInfoGetErrors, GetDocumentClassificationDocumentsKeyClassificationsGetData, GetDocumentClassificationDocumentsKeyClassificationsGetResponses, GetDocumentClassificationDocumentsKeyClassificationsGetErrors, GetDocumentClassificationReviewDocumentsKeyClassificationReviewsGetData, GetDocumentClassificationReviewDocumentsKeyClassificationReviewsGetResponses, GetDocumentClassificationReviewDocumentsKeyClassificationReviewsGetErrors, AddDocumentClassificationReviewDocumentsKeyClassificationReviewsPostData, AddDocumentClassificationReviewDocumentsKeyClassificationReviewsPostResponses, AddDocumentClassificationReviewDocumentsKeyClassificationReviewsPostErrors, GetDocumentExtractedDataDocumentsKeyExtractedDataGetData, GetDocumentExtractedDataDocumentsKeyExtractedDataGetResponses, GetDocumentExtractedDataDocumentsKeyExtractedDataGetErrors, GetDocumentExtractedDataDocumentsKeyExtractedDataLlmGetData, GetDocumentExtractedDataDocumentsKeyExtractedDataLlmGetResponses, GetDocumentExtractedDataDocumentsKeyExtractedDataLlmGetErrors, GetDocumentExtractedDataReviewDocumentsKeyExtractedDataReviewsGetData, GetDocumentExtractedDataReviewDocumentsKeyExtractedDataReviewsGetResponses, GetDocumentExtractedDataReviewDocumentsKeyExtractedDataReviewsGetErrors, AddDocumentExtractedDataReviewDocumentsKeyExtractedDataReviewsPostData, AddDocumentExtractedDataReviewDocumentsKeyExtractedDataReviewsPostResponses, AddDocumentExtractedDataReviewDocumentsKeyExtractedDataReviewsPostErrors, GetDocumentPatientMatchesDocumentsKeyPatientMatchesGetData, GetDocumentPatientMatchesDocumentsKeyPatientMatchesGetResponses, GetDocumentPatientMatchesDocumentsKeyPatientMatchesGetErrors, GetPatientCaseMatchFeedbackDocumentsKeyPatientMatchesFeedbackGetData, GetPatientCaseMatchFeedbackDocumentsKeyPatientMatchesFeedbackGetResponses, GetPatientCaseMatchFeedbackDocumentsKeyPatientMatchesFeedbackGetErrors, SubmitPatientCaseMatchFeedbackDocumentsKeyPatientMatchesFeedbackPostData, SubmitPatientCaseMatchFeedbackDocumentsKeyPatientMatchesFeedbackPostResponses, SubmitPatientCaseMatchFeedbackDocumentsKeyPatientMatchesFeedbackPostErrors, AddPatientRecordDocumentsKeyPatientMatchesRecordsPostData, AddPatientRecordDocumentsKeyPatientMatchesRecordsPostResponses, AddPatientRecordDocumentsKeyPatientMatchesRecordsPostErrors, DeletePatientRecordDocumentsKeyPatientMatchesRecordsIndexDeleteData, DeletePatientRecordDocumentsKeyPatientMatchesRecordsIndexDeleteResponses, DeletePatientRecordDocumentsKeyPatientMatchesRecordsIndexDeleteErrors, EditPatientRecordDocumentsKeyPatientMatchesRecordsIndexPutData, EditPatientRecordDocumentsKeyPatientMatchesRecordsIndexPutResponses, EditPatientRecordDocumentsKeyPatientMatchesRecordsIndexPutErrors, GetDocumentPatientPaMatchesDocumentsKeyPatientPaMatchesGetData, GetDocumentPatientPaMatchesDocumentsKeyPatientPaMatchesGetResponses, GetDocumentPatientPaMatchesDocumentsKeyPatientPaMatchesGetErrors, GetPaCaseMatchFeedbackDocumentsKeyPatientPaMatchesFeedbackGetData, GetPaCaseMatchFeedbackDocumentsKeyPatientPaMatchesFeedbackGetResponses, GetPaCaseMatchFeedbackDocumentsKeyPatientPaMatchesFeedbackGetErrors, SubmitPaCaseMatchFeedbackDocumentsKeyPatientPaMatchesFeedbackPostData, SubmitPaCaseMatchFeedbackDocumentsKeyPatientPaMatchesFeedbackPostResponses, SubmitPaCaseMatchFeedbackDocumentsKeyPatientPaMatchesFeedbackPostErrors, AddPaPatientRecordDocumentsKeyPatientPaMatchesRecordsPostData, AddPaPatientRecordDocumentsKeyPatientPaMatchesRecordsPostResponses, AddPaPatientRecordDocumentsKeyPatientPaMatchesRecordsPostErrors, DeletePaPatientRecordDocumentsKeyPatientPaMatchesRecordsIndexDeleteData, DeletePaPatientRecordDocumentsKeyPatientPaMatchesRecordsIndexDeleteResponses, DeletePaPatientRecordDocumentsKeyPatientPaMatchesRecordsIndexDeleteErrors, EditPaPatientRecordDocumentsKeyPatientPaMatchesRecordsIndexPutData, EditPaPatientRecordDocumentsKeyPatientPaMatchesRecordsIndexPutResponses, EditPaPatientRecordDocumentsKeyPatientPaMatchesRecordsIndexPutErrors, UpdateDocumentPayorDocumentsKeyPayorPutData, UpdateDocumentPayorDocumentsKeyPayorPutResponses, UpdateDocumentPayorDocumentsKeyPayorPutErrors, UpdateDocumentOnshoreOnlyFlagDocumentsKeyOnshoreOnlyPutData, UpdateDocumentOnshoreOnlyFlagDocumentsKeyOnshoreOnlyPutResponses, UpdateDocumentOnshoreOnlyFlagDocumentsKeyOnshoreOnlyPutErrors, DeleteDocumentThirdPartyDocumentsKeyThirdPartyDeleteData, DeleteDocumentThirdPartyDocumentsKeyThirdPartyDeleteResponses, DeleteDocumentThirdPartyDocumentsKeyThirdPartyDeleteErrors, UpdateDocumentThirdPartyDocumentsKeyThirdPartyPutData, UpdateDocumentThirdPartyDocumentsKeyThirdPartyPutResponses, UpdateDocumentThirdPartyDocumentsKeyThirdPartyPutErrors, GetDocumentTagsDocumentsKeyTagsGetData, GetDocumentTagsDocumentsKeyTagsGetResponses, GetDocumentTagsDocumentsKeyTagsGetErrors, GetDocumentTagsReviewsDocumentsKeyTagsReviewsGetData, GetDocumentTagsReviewsDocumentsKeyTagsReviewsGetResponses, GetDocumentTagsReviewsDocumentsKeyTagsReviewsGetErrors, CreateDocumentTagsReviewDocumentsKeyTagsReviewsPostData, CreateDocumentTagsReviewDocumentsKeyTagsReviewsPostResponses, CreateDocumentTagsReviewDocumentsKeyTagsReviewsPostErrors, UpdateDocumentReviewStatusDocumentsKeyReviewStatusPutData, UpdateDocumentReviewStatusDocumentsKeyReviewStatusPutResponses, UpdateDocumentReviewStatusDocumentsKeyReviewStatusPutErrors, GetDocumentFlagsDocumentsKeyFlagsGetData, GetDocumentFlagsDocumentsKeyFlagsGetResponses, GetDocumentFlagsDocumentsKeyFlagsGetErrors, CreateDocumentFlagDocumentsKeyFlagsPostData, CreateDocumentFlagDocumentsKeyFlagsPostResponses, CreateDocumentFlagDocumentsKeyFlagsPostErrors, UpdateDocumentFlagDocumentsKeyFlagsFlagKeyPatchData, UpdateDocumentFlagDocumentsKeyFlagsFlagKeyPatchResponses, UpdateDocumentFlagDocumentsKeyFlagsFlagKeyPatchErrors, AddDocumentFlagCommentDocumentsKeyFlagsFlagKeyCommentPostData, AddDocumentFlagCommentDocumentsKeyFlagsFlagKeyCommentPostResponses, AddDocumentFlagCommentDocumentsKeyFlagsFlagKeyCommentPostErrors, ResolveDocumentFlagDocumentsKeyFlagsFlagKeyResolvePostData, ResolveDocumentFlagDocumentsKeyFlagsFlagKeyResolvePostResponses, ResolveDocumentFlagDocumentsKeyFlagsFlagKeyResolvePostErrors, ListConsignmentsConsignmentsGetData, ListConsignmentsConsignmentsGetResponses, ListConsignmentsConsignmentsGetErrors, GetConsignmentConsignmentsKeyGetData, GetConsignmentConsignmentsKeyGetResponses, GetConsignmentConsignmentsKeyGetErrors, UpdateClusterDocumentPageRangesConsignmentsKeyDocumentPageRangesPutData, UpdateClusterDocumentPageRangesConsignmentsKeyDocumentPageRangesPutResponses, UpdateClusterDocumentPageRangesConsignmentsKeyDocumentPageRangesPutErrors, GetConsignmentPdfUrlConsignmentsKeyPdfGetData, GetConsignmentPdfUrlConsignmentsKeyPdfGetResponses, GetConsignmentPdfUrlConsignmentsKeyPdfGetErrors, GetConsignmentOcrLayoutUrlConsignmentsKeyOcrLayoutGetData, GetConsignmentOcrLayoutUrlConsignmentsKeyOcrLayoutGetResponses, GetConsignmentOcrLayoutUrlConsignmentsKeyOcrLayoutGetErrors, AssignReviewerToConsignmentConsignmentsKeyReviewerPostData, AssignReviewerToConsignmentConsignmentsKeyReviewerPostResponses, AssignReviewerToConsignmentConsignmentsKeyReviewerPostErrors, GetPdfUploadUrlConsignmentsUploadPdfPostData, GetPdfUploadUrlConsignmentsUploadPdfPostResponses, GetPdfUploadUrlConsignmentsUploadPdfPostErrors, ListCategoriesCategoriesGetData, ListCategoriesCategoriesGetResponses, ListPayorsPayorsGetData, ListPayorsPayorsGetResponses, ListReviewersReviewersGetData, ListReviewersReviewersGetResponses, GetReviewerBySubReviewersSubGetData, GetReviewerBySubReviewersSubGetResponses, GetReviewerBySubReviewersSubGetErrors, ListInboxNamesInboxNamesGetData, ListInboxNamesInboxNamesGetResponses, GetCurrentUserProfileWithFeaturesMeGetData, GetCurrentUserProfileWithFeaturesMeGetResponses, ListAvalonCompletionsAvalonCompletionsGetData, ListAvalonCompletionsAvalonCompletionsGetResponses, ListAvalonCompletionsAvalonCompletionsGetErrors, GetPaymentSummaryDocumentsDocumentKeyEobSummaryGetData, GetPaymentSummaryDocumentsDocumentKeyEobSummaryGetResponses, GetPaymentSummaryDocumentsDocumentKeyEobSummaryGetErrors, UpdatePaymentSummaryDocumentsDocumentKeyEobSummaryPutData, UpdatePaymentSummaryDocumentsDocumentKeyEobSummaryPutResponses, UpdatePaymentSummaryDocumentsDocumentKeyEobSummaryPutErrors, GetAllPatientClaimsDocumentsDocumentKeyEobClaimsGetData, GetAllPatientClaimsDocumentsDocumentKeyEobClaimsGetResponses, GetAllPatientClaimsDocumentsDocumentKeyEobClaimsGetErrors, CreatePatientClaimDocumentsDocumentKeyEobClaimsPostData, CreatePatientClaimDocumentsDocumentKeyEobClaimsPostResponses, CreatePatientClaimDocumentsDocumentKeyEobClaimsPostErrors, DeletePatientClaimDocumentsDocumentKeyEobClaimsClaimKeyDeleteData, DeletePatientClaimDocumentsDocumentKeyEobClaimsClaimKeyDeleteResponses, DeletePatientClaimDocumentsDocumentKeyEobClaimsClaimKeyDeleteErrors, UpdatePatientClaimDocumentsDocumentKeyEobClaimsClaimKeyPutData, UpdatePatientClaimDocumentsDocumentKeyEobClaimsClaimKeyPutResponses, UpdatePatientClaimDocumentsDocumentKeyEobClaimsClaimKeyPutErrors, ValidateEobProcessingDocumentsDocumentKeyEobValidatePostData, ValidateEobProcessingDocumentsDocumentKeyEobValidatePostResponses, ValidateEobProcessingDocumentsDocumentKeyEobValidatePostErrors, ListCarCsConfigCarcsGetData, ListCarCsConfigCarcsGetResponses, ListCarCsConfigCarcsGetErrors, ListRarCsConfigRarcsGetData, ListRarCsConfigRarcsGetResponses, ListRarCsConfigRarcsGetErrors, ListNateraTagsConfigTagsGetData, ListNateraTagsConfigTagsGetResponses, GetCarcToRarcMappingConfigCarcToRarcGetData, GetCarcToRarcMappingConfigCarcToRarcGetResponses, ListMedistreamConsignmentsMedistreamTrackingGetData, ListMedistreamConsignmentsMedistreamTrackingGetResponses, ListMedistreamConsignmentsMedistreamTrackingGetErrors, MedistreamTrackingSummaryMedistreamTrackingSummaryGetData, MedistreamTrackingSummaryMedistreamTrackingSummaryGetResponses, DownloadMedistreamTrackingReportCsvMedistreamTrackingReportGetData, DownloadMedistreamTrackingReportCsvMedistreamTrackingReportGetResponses, DownloadMedistreamTrackingReportCsvMedistreamTrackingReportGetErrors, MedistreamTrackingReportSummaryMedistreamTrackingReportSummaryGetData, MedistreamTrackingReportSummaryMedistreamTrackingReportSummaryGetResponses, MedistreamTrackingReportSummaryMedistreamTrackingReportSummaryGetErrors, RefreshMedistreamTrackingReportMedistreamTrackingReportRefreshPostData, RefreshMedistreamTrackingReportMedistreamTrackingReportRefreshPostResponses, RefreshMedistreamTrackingReportMedistreamTrackingReportRefreshPostErrors, ListDocumentsWithAgentRunsDocumentAgentRunsGetData, ListDocumentsWithAgentRunsDocumentAgentRunsGetResponses, ListDocumentsWithAgentRunsDocumentAgentRunsGetErrors, ListADocumentSAgentRunsDocumentAgentDocumentsKeyRunsGetData, ListADocumentSAgentRunsDocumentAgentDocumentsKeyRunsGetResponses, ListADocumentSAgentRunsDocumentAgentDocumentsKeyRunsGetErrors, GetAnAgentRunDocumentAgentDocumentsKeyRunsRunIdGetData, GetAnAgentRunDocumentAgentDocumentsKeyRunsRunIdGetResponses, GetAnAgentRunDocumentAgentDocumentsKeyRunsRunIdGetErrors, GetTheDocumentTextTheAgentReadDocumentAgentDocumentsKeyTextGetData, GetTheDocumentTextTheAgentReadDocumentAgentDocumentsKeyTextGetResponses, GetTheDocumentTextTheAgentReadDocumentAgentDocumentsKeyTextGetErrors, GetTheGoldSetReviewQueueGoldSetQueueGetData, GetTheGoldSetReviewQueueGoldSetQueueGetResponses, GetTheGoldSetReviewQueueGoldSetQueueGetErrors, ListTheGoldSetCategoriesGoldSetCategoriesGetData, ListTheGoldSetCategoriesGoldSetCategoriesGetResponses, GetAGoldSetDocumentGoldSetDocumentsKeyGetData, GetAGoldSetDocumentGoldSetDocumentsKeyGetResponses, GetAGoldSetDocumentGoldSetDocumentsKeyGetErrors, SaveAGoldSetLabelGoldSetDocumentsKeyLabelPutData, SaveAGoldSetLabelGoldSetDocumentsKeyLabelPutResponses, SaveAGoldSetLabelGoldSetDocumentsKeyLabelPutErrors } from './types.gen';
import { client as _heyApiClient } from './client.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = ClientOptions<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * List Documents
 */
export const listDocumentsDocumentsGet = <ThrowOnError extends boolean = false>(options?: Options<ListDocumentsDocumentsGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListDocumentsDocumentsGetResponses, ListDocumentsDocumentsGetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/documents',
        ...options
    });
};

/**
 * Get Document
 */
export const getDocumentDocumentsKeyGet = <ThrowOnError extends boolean = false>(options: Options<GetDocumentDocumentsKeyGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetDocumentDocumentsKeyGetResponses, GetDocumentDocumentsKeyGetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/documents/{key}',
        ...options
    });
};

/**
 * Load a document and all of its related data in a single request
 * Return the full document view (document + clusters, classifications,
 * extracted data, tags, patient matches, flags, EOB, and reviews) assembled
 * from a single partition query, replacing the many per-object calls.
 */
export const getDocumentSnapshotDocumentsKeySnapshotGet = <ThrowOnError extends boolean = false>(options: Options<GetDocumentSnapshotDocumentsKeySnapshotGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetDocumentSnapshotDocumentsKeySnapshotGetResponses, GetDocumentSnapshotDocumentsKeySnapshotGetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/documents/{key}/snapshot',
        ...options
    });
};

/**
 * Get Document Pdf Url
 */
export const getDocumentPdfUrlDocumentsKeyPdfGet = <ThrowOnError extends boolean = false>(options: Options<GetDocumentPdfUrlDocumentsKeyPdfGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetDocumentPdfUrlDocumentsKeyPdfGetResponses, GetDocumentPdfUrlDocumentsKeyPdfGetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/documents/{key}/pdf',
        ...options
    });
};

/**
 * Get document audit trail with optional filtering
 * Get audit trail for a document with optional filtering.
 *
 * - **event_type=eob**: Returns only EOB-related events (payment summary, claims, service lines)
 * - **event_type** omitted: Returns all audit events for the document
 *
 * This unified endpoint replaces the separate /eob/audit-trail endpoint for better frontend integration.
 */
export const getDocumentAuditTrailDocumentsKeyAuditTrailGet = <ThrowOnError extends boolean = false>(options: Options<GetDocumentAuditTrailDocumentsKeyAuditTrailGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetDocumentAuditTrailDocumentsKeyAuditTrailGetResponses, GetDocumentAuditTrailDocumentsKeyAuditTrailGetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/documents/{key}/audit-trail',
        ...options
    });
};

/**
 * Assign Reviewer To Document
 */
export const assignReviewerToDocumentDocumentsKeyReviewerPost = <ThrowOnError extends boolean = false>(options: Options<AssignReviewerToDocumentDocumentsKeyReviewerPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AssignReviewerToDocumentDocumentsKeyReviewerPostResponses, AssignReviewerToDocumentDocumentsKeyReviewerPostErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/documents/{key}/reviewer',
        ...options
    });
};

/**
 * Get Document Cluster Info
 */
export const getDocumentClusterInfoDocumentsKeyClusterInfoGet = <ThrowOnError extends boolean = false>(options: Options<GetDocumentClusterInfoDocumentsKeyClusterInfoGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetDocumentClusterInfoDocumentsKeyClusterInfoGetResponses, GetDocumentClusterInfoDocumentsKeyClusterInfoGetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/documents/{key}/cluster-info',
        ...options
    });
};

/**
 * Get Document Classification
 */
export const getDocumentClassificationDocumentsKeyClassificationsGet = <ThrowOnError extends boolean = false>(options: Options<GetDocumentClassificationDocumentsKeyClassificationsGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetDocumentClassificationDocumentsKeyClassificationsGetResponses, GetDocumentClassificationDocumentsKeyClassificationsGetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/documents/{key}/classifications',
        ...options
    });
};

/**
 * Get Document Classification Review
 */
export const getDocumentClassificationReviewDocumentsKeyClassificationReviewsGet = <ThrowOnError extends boolean = false>(options: Options<GetDocumentClassificationReviewDocumentsKeyClassificationReviewsGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetDocumentClassificationReviewDocumentsKeyClassificationReviewsGetResponses, GetDocumentClassificationReviewDocumentsKeyClassificationReviewsGetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/documents/{key}/classification-reviews',
        ...options
    });
};

/**
 * Add Document Classification Review
 */
export const addDocumentClassificationReviewDocumentsKeyClassificationReviewsPost = <ThrowOnError extends boolean = false>(options: Options<AddDocumentClassificationReviewDocumentsKeyClassificationReviewsPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AddDocumentClassificationReviewDocumentsKeyClassificationReviewsPostResponses, AddDocumentClassificationReviewDocumentsKeyClassificationReviewsPostErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/documents/{key}/classification-reviews',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Document Extracted Data
 */
export const getDocumentExtractedDataDocumentsKeyExtractedDataGet = <ThrowOnError extends boolean = false>(options: Options<GetDocumentExtractedDataDocumentsKeyExtractedDataGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetDocumentExtractedDataDocumentsKeyExtractedDataGetResponses, GetDocumentExtractedDataDocumentsKeyExtractedDataGetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/documents/{key}/extracted-data',
        ...options
    });
};

/**
 * Get Document Extracted Data
 */
export const getDocumentExtractedDataDocumentsKeyExtractedDataLlmGet = <ThrowOnError extends boolean = false>(options: Options<GetDocumentExtractedDataDocumentsKeyExtractedDataLlmGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetDocumentExtractedDataDocumentsKeyExtractedDataLlmGetResponses, GetDocumentExtractedDataDocumentsKeyExtractedDataLlmGetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/documents/{key}/extracted-data-llm',
        ...options
    });
};

/**
 * Get Document Extracted Data Review
 */
export const getDocumentExtractedDataReviewDocumentsKeyExtractedDataReviewsGet = <ThrowOnError extends boolean = false>(options: Options<GetDocumentExtractedDataReviewDocumentsKeyExtractedDataReviewsGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetDocumentExtractedDataReviewDocumentsKeyExtractedDataReviewsGetResponses, GetDocumentExtractedDataReviewDocumentsKeyExtractedDataReviewsGetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/documents/{key}/extracted-data-reviews',
        ...options
    });
};

/**
 * Add Document Extracted Data Review
 */
export const addDocumentExtractedDataReviewDocumentsKeyExtractedDataReviewsPost = <ThrowOnError extends boolean = false>(options: Options<AddDocumentExtractedDataReviewDocumentsKeyExtractedDataReviewsPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AddDocumentExtractedDataReviewDocumentsKeyExtractedDataReviewsPostResponses, AddDocumentExtractedDataReviewDocumentsKeyExtractedDataReviewsPostErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/documents/{key}/extracted-data-reviews',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Document Patient Matches
 */
export const getDocumentPatientMatchesDocumentsKeyPatientMatchesGet = <ThrowOnError extends boolean = false>(options: Options<GetDocumentPatientMatchesDocumentsKeyPatientMatchesGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetDocumentPatientMatchesDocumentsKeyPatientMatchesGetResponses, GetDocumentPatientMatchesDocumentsKeyPatientMatchesGetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/documents/{key}/patient-matches',
        ...options
    });
};

/**
 * Get Patient Case Match Feedback
 * Get patient case matching feedback/review data for a document
 */
export const getPatientCaseMatchFeedbackDocumentsKeyPatientMatchesFeedbackGet = <ThrowOnError extends boolean = false>(options: Options<GetPatientCaseMatchFeedbackDocumentsKeyPatientMatchesFeedbackGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetPatientCaseMatchFeedbackDocumentsKeyPatientMatchesFeedbackGetResponses, GetPatientCaseMatchFeedbackDocumentsKeyPatientMatchesFeedbackGetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/documents/{key}/patient-matches/feedback',
        ...options
    });
};

/**
 * Submit Patient Case Match Feedback
 */
export const submitPatientCaseMatchFeedbackDocumentsKeyPatientMatchesFeedbackPost = <ThrowOnError extends boolean = false>(options: Options<SubmitPatientCaseMatchFeedbackDocumentsKeyPatientMatchesFeedbackPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<SubmitPatientCaseMatchFeedbackDocumentsKeyPatientMatchesFeedbackPostResponses, SubmitPatientCaseMatchFeedbackDocumentsKeyPatientMatchesFeedbackPostErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/documents/{key}/patient-matches/feedback',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Add Patient Record
 * Add a new patient record to the patient_data array.
 */
export const addPatientRecordDocumentsKeyPatientMatchesRecordsPost = <ThrowOnError extends boolean = false>(options: Options<AddPatientRecordDocumentsKeyPatientMatchesRecordsPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AddPatientRecordDocumentsKeyPatientMatchesRecordsPostResponses, AddPatientRecordDocumentsKeyPatientMatchesRecordsPostErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/documents/{key}/patient-matches/records',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Delete Patient Record
 * Delete a patient record from the patient_data array.
 */
export const deletePatientRecordDocumentsKeyPatientMatchesRecordsIndexDelete = <ThrowOnError extends boolean = false>(options: Options<DeletePatientRecordDocumentsKeyPatientMatchesRecordsIndexDeleteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeletePatientRecordDocumentsKeyPatientMatchesRecordsIndexDeleteResponses, DeletePatientRecordDocumentsKeyPatientMatchesRecordsIndexDeleteErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/documents/{key}/patient-matches/records/{index}',
        ...options
    });
};

/**
 * Edit Patient Record
 * Edit an existing patient record in the patient_data array.
 */
export const editPatientRecordDocumentsKeyPatientMatchesRecordsIndexPut = <ThrowOnError extends boolean = false>(options: Options<EditPatientRecordDocumentsKeyPatientMatchesRecordsIndexPutData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<EditPatientRecordDocumentsKeyPatientMatchesRecordsIndexPutResponses, EditPatientRecordDocumentsKeyPatientMatchesRecordsIndexPutErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/documents/{key}/patient-matches/records/{index}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Document Patient Pa Matches
 */
export const getDocumentPatientPaMatchesDocumentsKeyPatientPaMatchesGet = <ThrowOnError extends boolean = false>(options: Options<GetDocumentPatientPaMatchesDocumentsKeyPatientPaMatchesGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetDocumentPatientPaMatchesDocumentsKeyPatientPaMatchesGetResponses, GetDocumentPatientPaMatchesDocumentsKeyPatientPaMatchesGetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/documents/{key}/patient-pa-matches',
        ...options
    });
};

/**
 * Get Pa Case Match Feedback
 * Get PA case matching feedback/review data for a document
 */
export const getPaCaseMatchFeedbackDocumentsKeyPatientPaMatchesFeedbackGet = <ThrowOnError extends boolean = false>(options: Options<GetPaCaseMatchFeedbackDocumentsKeyPatientPaMatchesFeedbackGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetPaCaseMatchFeedbackDocumentsKeyPatientPaMatchesFeedbackGetResponses, GetPaCaseMatchFeedbackDocumentsKeyPatientPaMatchesFeedbackGetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/documents/{key}/patient-pa-matches/feedback',
        ...options
    });
};

/**
 * Submit Pa Case Match Feedback
 */
export const submitPaCaseMatchFeedbackDocumentsKeyPatientPaMatchesFeedbackPost = <ThrowOnError extends boolean = false>(options: Options<SubmitPaCaseMatchFeedbackDocumentsKeyPatientPaMatchesFeedbackPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<SubmitPaCaseMatchFeedbackDocumentsKeyPatientPaMatchesFeedbackPostResponses, SubmitPaCaseMatchFeedbackDocumentsKeyPatientPaMatchesFeedbackPostErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/documents/{key}/patient-pa-matches/feedback',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Add Pa Patient Record
 * Add a new PA patient record to the patient_data array.
 */
export const addPaPatientRecordDocumentsKeyPatientPaMatchesRecordsPost = <ThrowOnError extends boolean = false>(options: Options<AddPaPatientRecordDocumentsKeyPatientPaMatchesRecordsPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AddPaPatientRecordDocumentsKeyPatientPaMatchesRecordsPostResponses, AddPaPatientRecordDocumentsKeyPatientPaMatchesRecordsPostErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/documents/{key}/patient-pa-matches/records',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Delete Pa Patient Record
 * Delete a PA patient record from the patient_data array.
 */
export const deletePaPatientRecordDocumentsKeyPatientPaMatchesRecordsIndexDelete = <ThrowOnError extends boolean = false>(options: Options<DeletePaPatientRecordDocumentsKeyPatientPaMatchesRecordsIndexDeleteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeletePaPatientRecordDocumentsKeyPatientPaMatchesRecordsIndexDeleteResponses, DeletePaPatientRecordDocumentsKeyPatientPaMatchesRecordsIndexDeleteErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/documents/{key}/patient-pa-matches/records/{index}',
        ...options
    });
};

/**
 * Edit Pa Patient Record
 * Edit an existing PA patient record in the patient_data array.
 */
export const editPaPatientRecordDocumentsKeyPatientPaMatchesRecordsIndexPut = <ThrowOnError extends boolean = false>(options: Options<EditPaPatientRecordDocumentsKeyPatientPaMatchesRecordsIndexPutData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<EditPaPatientRecordDocumentsKeyPatientPaMatchesRecordsIndexPutResponses, EditPaPatientRecordDocumentsKeyPatientPaMatchesRecordsIndexPutErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/documents/{key}/patient-pa-matches/records/{index}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Update Document Payor
 * Update document payor information.
 *
 * Accepts a payor_id and automatically looks up the corresponding
 * payor_group_id and onshore_only flag from the payors definitions.
 */
export const updateDocumentPayorDocumentsKeyPayorPut = <ThrowOnError extends boolean = false>(options: Options<UpdateDocumentPayorDocumentsKeyPayorPutData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<UpdateDocumentPayorDocumentsKeyPayorPutResponses, UpdateDocumentPayorDocumentsKeyPayorPutErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/documents/{key}/payor',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Update Document Onshore Only Flag
 */
export const updateDocumentOnshoreOnlyFlagDocumentsKeyOnshoreOnlyPut = <ThrowOnError extends boolean = false>(options: Options<UpdateDocumentOnshoreOnlyFlagDocumentsKeyOnshoreOnlyPutData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<UpdateDocumentOnshoreOnlyFlagDocumentsKeyOnshoreOnlyPutResponses, UpdateDocumentOnshoreOnlyFlagDocumentsKeyOnshoreOnlyPutErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/documents/{key}/onshore-only',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Delete Document Third Party
 * Remove third party company information from document.
 */
export const deleteDocumentThirdPartyDocumentsKeyThirdPartyDelete = <ThrowOnError extends boolean = false>(options: Options<DeleteDocumentThirdPartyDocumentsKeyThirdPartyDeleteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteDocumentThirdPartyDocumentsKeyThirdPartyDeleteResponses, DeleteDocumentThirdPartyDocumentsKeyThirdPartyDeleteErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/documents/{key}/third-party',
        ...options
    });
};

/**
 * Update Document Third Party
 * Update document third party company information.
 */
export const updateDocumentThirdPartyDocumentsKeyThirdPartyPut = <ThrowOnError extends boolean = false>(options: Options<UpdateDocumentThirdPartyDocumentsKeyThirdPartyPutData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<UpdateDocumentThirdPartyDocumentsKeyThirdPartyPutResponses, UpdateDocumentThirdPartyDocumentsKeyThirdPartyPutErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/documents/{key}/third-party',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Document Tags
 * Get all tags (CARC, RARC, Triple P) for a document.
 *
 * Returns:
 * - For new docs (tags-* exists): Returns tags-* data with key="tags-xxx"
 * - For old docs (only data-*): Fallback to data-*, returns key="data-xxx"
 *
 * The frontend should use the returned `key` value as `data_key` in POST requests.
 * (For backward compatibility the API also accepts the legacy name `data_key`.)
 */
export const getDocumentTagsDocumentsKeyTagsGet = <ThrowOnError extends boolean = false>(options: Options<GetDocumentTagsDocumentsKeyTagsGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetDocumentTagsDocumentsKeyTagsGetResponses, GetDocumentTagsDocumentsKeyTagsGetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/documents/{key}/tags',
        ...options
    });
};

/**
 * Get Document Tags Reviews
 * Get review history for tags.
 *
 * Returns all reviews (datarev-* for audit trail).
 * Mirror write ensures this is always up to date regardless of which model was used.
 */
export const getDocumentTagsReviewsDocumentsKeyTagsReviewsGet = <ThrowOnError extends boolean = false>(options: Options<GetDocumentTagsReviewsDocumentsKeyTagsReviewsGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetDocumentTagsReviewsDocumentsKeyTagsReviewsGetResponses, GetDocumentTagsReviewsDocumentsKeyTagsReviewsGetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/documents/{key}/tags/reviews',
        ...options
    });
};

/**
 * Create Document Tags Review
 * Create a new tags review with mirror write.
 *
 * Routes by key prefix (request accepts `data_key` or legacy `data_key`):
 * - "data-xxx" → legacy extracted data model
 * - "tags-xxx" → new tags model
 *
 * Both flows perform mirror write to keep old and new models in sync.
 */
export const createDocumentTagsReviewDocumentsKeyTagsReviewsPost = <ThrowOnError extends boolean = false>(options: Options<CreateDocumentTagsReviewDocumentsKeyTagsReviewsPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateDocumentTagsReviewDocumentsKeyTagsReviewsPostResponses, CreateDocumentTagsReviewDocumentsKeyTagsReviewsPostErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/documents/{key}/tags/reviews',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Update Document Review Status
 */
export const updateDocumentReviewStatusDocumentsKeyReviewStatusPut = <ThrowOnError extends boolean = false>(options: Options<UpdateDocumentReviewStatusDocumentsKeyReviewStatusPutData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<UpdateDocumentReviewStatusDocumentsKeyReviewStatusPutResponses, UpdateDocumentReviewStatusDocumentsKeyReviewStatusPutErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/documents/{key}/review-status',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Document Flags
 * Get all flags for a document
 */
export const getDocumentFlagsDocumentsKeyFlagsGet = <ThrowOnError extends boolean = false>(options: Options<GetDocumentFlagsDocumentsKeyFlagsGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetDocumentFlagsDocumentsKeyFlagsGetResponses, GetDocumentFlagsDocumentsKeyFlagsGetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/documents/{key}/flags',
        ...options
    });
};

/**
 * Create Document Flag
 * Create a new flag for a document
 */
export const createDocumentFlagDocumentsKeyFlagsPost = <ThrowOnError extends boolean = false>(options: Options<CreateDocumentFlagDocumentsKeyFlagsPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateDocumentFlagDocumentsKeyFlagsPostResponses, CreateDocumentFlagDocumentsKeyFlagsPostErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/documents/{key}/flags',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Update Document Flag
 * Update an existing flag (only notes and metadata are mutable)
 */
export const updateDocumentFlagDocumentsKeyFlagsFlagKeyPatch = <ThrowOnError extends boolean = false>(options: Options<UpdateDocumentFlagDocumentsKeyFlagsFlagKeyPatchData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdateDocumentFlagDocumentsKeyFlagsFlagKeyPatchResponses, UpdateDocumentFlagDocumentsKeyFlagsFlagKeyPatchErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/documents/{key}/flags/{flagKey}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Add Document Flag Comment
 * Add a comment to an existing flag without changing document state.
 */
export const addDocumentFlagCommentDocumentsKeyFlagsFlagKeyCommentPost = <ThrowOnError extends boolean = false>(options: Options<AddDocumentFlagCommentDocumentsKeyFlagsFlagKeyCommentPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AddDocumentFlagCommentDocumentsKeyFlagsFlagKeyCommentPostResponses, AddDocumentFlagCommentDocumentsKeyFlagsFlagKeyCommentPostErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/documents/{key}/flags/{flagKey}/comment',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Resolve Document Flag
 * Resolve a flag
 */
export const resolveDocumentFlagDocumentsKeyFlagsFlagKeyResolvePost = <ThrowOnError extends boolean = false>(options: Options<ResolveDocumentFlagDocumentsKeyFlagsFlagKeyResolvePostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ResolveDocumentFlagDocumentsKeyFlagsFlagKeyResolvePostResponses, ResolveDocumentFlagDocumentsKeyFlagsFlagKeyResolvePostErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/documents/{key}/flags/{flagKey}/resolve',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List Consignments
 */
export const listConsignmentsConsignmentsGet = <ThrowOnError extends boolean = false>(options?: Options<ListConsignmentsConsignmentsGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListConsignmentsConsignmentsGetResponses, ListConsignmentsConsignmentsGetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/consignments',
        ...options
    });
};

/**
 * Get Consignment
 */
export const getConsignmentConsignmentsKeyGet = <ThrowOnError extends boolean = false>(options: Options<GetConsignmentConsignmentsKeyGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetConsignmentConsignmentsKeyGetResponses, GetConsignmentConsignmentsKeyGetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/consignments/{key}',
        ...options
    });
};

/**
 * Update Cluster Document Page Ranges
 */
export const updateClusterDocumentPageRangesConsignmentsKeyDocumentPageRangesPut = <ThrowOnError extends boolean = false>(options: Options<UpdateClusterDocumentPageRangesConsignmentsKeyDocumentPageRangesPutData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<UpdateClusterDocumentPageRangesConsignmentsKeyDocumentPageRangesPutResponses, UpdateClusterDocumentPageRangesConsignmentsKeyDocumentPageRangesPutErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/consignments/{key}/document-page-ranges',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Consignment Pdf Url
 */
export const getConsignmentPdfUrlConsignmentsKeyPdfGet = <ThrowOnError extends boolean = false>(options: Options<GetConsignmentPdfUrlConsignmentsKeyPdfGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetConsignmentPdfUrlConsignmentsKeyPdfGetResponses, GetConsignmentPdfUrlConsignmentsKeyPdfGetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/consignments/{key}/pdf',
        ...options
    });
};

/**
 * Get Consignment Ocr Layout Url
 */
export const getConsignmentOcrLayoutUrlConsignmentsKeyOcrLayoutGet = <ThrowOnError extends boolean = false>(options: Options<GetConsignmentOcrLayoutUrlConsignmentsKeyOcrLayoutGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetConsignmentOcrLayoutUrlConsignmentsKeyOcrLayoutGetResponses, GetConsignmentOcrLayoutUrlConsignmentsKeyOcrLayoutGetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/consignments/{key}/ocr-layout',
        ...options
    });
};

/**
 * Assign Reviewer To Consignment
 */
export const assignReviewerToConsignmentConsignmentsKeyReviewerPost = <ThrowOnError extends boolean = false>(options: Options<AssignReviewerToConsignmentConsignmentsKeyReviewerPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AssignReviewerToConsignmentConsignmentsKeyReviewerPostResponses, AssignReviewerToConsignmentConsignmentsKeyReviewerPostErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/consignments/{key}/reviewer',
        ...options
    });
};

/**
 * Get Pdf Upload Url
 */
export const getPdfUploadUrlConsignmentsUploadPdfPost = <ThrowOnError extends boolean = false>(options: Options<GetPdfUploadUrlConsignmentsUploadPdfPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<GetPdfUploadUrlConsignmentsUploadPdfPostResponses, GetPdfUploadUrlConsignmentsUploadPdfPostErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/consignments/upload/pdf',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List Categories
 */
export const listCategoriesCategoriesGet = <ThrowOnError extends boolean = false>(options?: Options<ListCategoriesCategoriesGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListCategoriesCategoriesGetResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/categories',
        ...options
    });
};

/**
 * List Payors
 * Get all payors definitions.
 */
export const listPayorsPayorsGet = <ThrowOnError extends boolean = false>(options?: Options<ListPayorsPayorsGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListPayorsPayorsGetResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/payors',
        ...options
    });
};

/**
 * List Reviewers
 */
export const listReviewersReviewersGet = <ThrowOnError extends boolean = false>(options?: Options<ListReviewersReviewersGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListReviewersReviewersGetResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/reviewers',
        ...options
    });
};

/**
 * Get Reviewer By Sub
 */
export const getReviewerBySubReviewersSubGet = <ThrowOnError extends boolean = false>(options: Options<GetReviewerBySubReviewersSubGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetReviewerBySubReviewersSubGetResponses, GetReviewerBySubReviewersSubGetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/reviewers/{sub}',
        ...options
    });
};

/**
 * List Inbox Names
 */
export const listInboxNamesInboxNamesGet = <ThrowOnError extends boolean = false>(options?: Options<ListInboxNamesInboxNamesGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListInboxNamesInboxNamesGetResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/inbox_names',
        ...options
    });
};

/**
 * Get Current User Profile With Features
 * Get the current user's profile information including Unleash feature flags.
 *
 * Returns:
 * UserProfile: User information with feature flags
 */
export const getCurrentUserProfileWithFeaturesMeGet = <ThrowOnError extends boolean = false>(options?: Options<GetCurrentUserProfileWithFeaturesMeGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetCurrentUserProfileWithFeaturesMeGetResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/me',
        ...options
    });
};

/**
 * List Avalon Completions
 */
export const listAvalonCompletionsAvalonCompletionsGet = <ThrowOnError extends boolean = false>(options?: Options<ListAvalonCompletionsAvalonCompletionsGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListAvalonCompletionsAvalonCompletionsGetResponses, ListAvalonCompletionsAvalonCompletionsGetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/avalon-completions',
        ...options
    });
};

/**
 * Get payment summary for document
 * Get payment summary including workflow state fields.
 *
 * **Returns:** PaymentSummary with existing fields + workflow state
 */
export const getPaymentSummaryDocumentsDocumentKeyEobSummaryGet = <ThrowOnError extends boolean = false>(options: Options<GetPaymentSummaryDocumentsDocumentKeyEobSummaryGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetPaymentSummaryDocumentsDocumentKeyEobSummaryGetResponses, GetPaymentSummaryDocumentsDocumentKeyEobSummaryGetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/documents/{document_key}/eob/summary',
        ...options
    });
};

/**
 * Update payment summary with workflow state
 * Update payment summary including workflow state fields.
 *
 * **Supports:** receipt_confirmed, no_duplicates_in_amd, status updates
 */
export const updatePaymentSummaryDocumentsDocumentKeyEobSummaryPut = <ThrowOnError extends boolean = false>(options: Options<UpdatePaymentSummaryDocumentsDocumentKeyEobSummaryPutData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<UpdatePaymentSummaryDocumentsDocumentKeyEobSummaryPutResponses, UpdatePaymentSummaryDocumentsDocumentKeyEobSummaryPutErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/documents/{document_key}/eob/summary',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get all patient claims with embedded service lines
 * Get all patient claims for document with embedded service lines.
 *
 * **Returns:** List of PatientClaims, each containing service_lines array
 */
export const getAllPatientClaimsDocumentsDocumentKeyEobClaimsGet = <ThrowOnError extends boolean = false>(options: Options<GetAllPatientClaimsDocumentsDocumentKeyEobClaimsGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetAllPatientClaimsDocumentsDocumentKeyEobClaimsGetResponses, GetAllPatientClaimsDocumentsDocumentKeyEobClaimsGetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/documents/{document_key}/eob/claims',
        ...options
    });
};

/**
 * Create patient claim with optional service lines
 * Create patient claim with optional bulk service lines creation.
 *
 * **Example request:**
 * ```json
 * {
 * "patient_account_number": "12345",
 * "total_charged_amount": "500.00",
 * "service_lines": [
 * {
 * "procedure_code": "99213",
 * "charged_amount": "200.00",
 * "service_date": "2024-03-10"
 * },
 * {
 * "procedure_code": "99214",
 * "charged_amount": "300.00",
 * "service_date": "2024-03-10"
 * }
 * ]
 * }
 * ```
 *
 * **Returns:** Created PatientClaim with embedded service_lines
 */
export const createPatientClaimDocumentsDocumentKeyEobClaimsPost = <ThrowOnError extends boolean = false>(options: Options<CreatePatientClaimDocumentsDocumentKeyEobClaimsPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreatePatientClaimDocumentsDocumentKeyEobClaimsPostResponses, CreatePatientClaimDocumentsDocumentKeyEobClaimsPostErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/documents/{document_key}/eob/claims',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Delete patient claim (cascade deletes service lines)
 * Delete patient claim (soft delete with cascade to service lines).
 */
export const deletePatientClaimDocumentsDocumentKeyEobClaimsClaimKeyDelete = <ThrowOnError extends boolean = false>(options: Options<DeletePatientClaimDocumentsDocumentKeyEobClaimsClaimKeyDeleteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeletePatientClaimDocumentsDocumentKeyEobClaimsClaimKeyDeleteResponses, DeletePatientClaimDocumentsDocumentKeyEobClaimsClaimKeyDeleteErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/documents/{document_key}/eob/claims/{claim_key}',
        ...options
    });
};

/**
 * Update patient claim with bulk service line operations
 * Update patient claim with bulk service line diff operations.
 *
 * **Critical Bulk Operations Logic:**
 * - Missing service_line_id: CREATE new service line
 * - Existing service_line_id: UPDATE existing service line
 * - Service lines in DB but not in request: DELETE from DB
 * - Empty service_lines array: DELETE all existing service lines
 *
 * **Example request:**
 * ```json
 * {
 * "total_charged_amount": "600.00",
 * "service_lines": [
 * {
 * "service_line_id": "LINE-ABC123",
 * "procedure_code": "99213",
 * "charged_amount": "250.00"
 * },
 * {
 * "procedure_code": "99215",
 * "charged_amount": "350.00"
 * }
 * ]
 * }
 * ```
 *
 * **Returns:** Updated PatientClaim with all current service_lines
 */
export const updatePatientClaimDocumentsDocumentKeyEobClaimsClaimKeyPut = <ThrowOnError extends boolean = false>(options: Options<UpdatePatientClaimDocumentsDocumentKeyEobClaimsClaimKeyPutData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<UpdatePatientClaimDocumentsDocumentKeyEobClaimsClaimKeyPutResponses, UpdatePatientClaimDocumentsDocumentKeyEobClaimsClaimKeyPutErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/documents/{document_key}/eob/claims/{claim_key}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Mark EOB document as reviewed and complete processing
 * Mark EOB document processing as complete and reviewed.
 *
 * Sets document review_status to REVIEWED and creates an audit trail event
 * with type EOB_PROCESSING_FINISHED to track the validation action.
 *
 * **Returns:** Status confirmation with new review status
 */
export const validateEobProcessingDocumentsDocumentKeyEobValidatePost = <ThrowOnError extends boolean = false>(options: Options<ValidateEobProcessingDocumentsDocumentKeyEobValidatePostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ValidateEobProcessingDocumentsDocumentKeyEobValidatePostResponses, ValidateEobProcessingDocumentsDocumentKeyEobValidatePostErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/documents/{document_key}/eob/validate',
        ...options
    });
};

/**
 * List Carcs
 */
export const listCarCsConfigCarcsGet = <ThrowOnError extends boolean = false>(options?: Options<ListCarCsConfigCarcsGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListCarCsConfigCarcsGetResponses, ListCarCsConfigCarcsGetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/config/carcs',
        ...options
    });
};

/**
 * List Rarcs
 */
export const listRarCsConfigRarcsGet = <ThrowOnError extends boolean = false>(options?: Options<ListRarCsConfigRarcsGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListRarCsConfigRarcsGetResponses, ListRarCsConfigRarcsGetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/config/rarcs',
        ...options
    });
};

/**
 * List Natera Tags
 */
export const listNateraTagsConfigTagsGet = <ThrowOnError extends boolean = false>(options?: Options<ListNateraTagsConfigTagsGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListNateraTagsConfigTagsGetResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/config/tags',
        ...options
    });
};

/**
 * Get Carc To Rarc Mapping
 */
export const getCarcToRarcMappingConfigCarcToRarcGet = <ThrowOnError extends boolean = false>(options?: Options<GetCarcToRarcMappingConfigCarcToRarcGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetCarcToRarcMappingConfigCarcToRarcGetResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/config/carc-to-rarc',
        ...options
    });
};

/**
 * List Medistream Consignments
 */
export const listMedistreamConsignmentsMedistreamTrackingGet = <ThrowOnError extends boolean = false>(options?: Options<ListMedistreamConsignmentsMedistreamTrackingGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListMedistreamConsignmentsMedistreamTrackingGetResponses, ListMedistreamConsignmentsMedistreamTrackingGetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/medistream-tracking',
        ...options
    });
};

/**
 * Medistream Tracking Summary
 */
export const medistreamTrackingSummaryMedistreamTrackingSummaryGet = <ThrowOnError extends boolean = false>(options?: Options<MedistreamTrackingSummaryMedistreamTrackingSummaryGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<MedistreamTrackingSummaryMedistreamTrackingSummaryGetResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/medistream-tracking/summary',
        ...options
    });
};

/**
 * Download Medistream Tracking Report Csv
 * Return a presigned URL for the full report CSV.
 *
 * Rendered from the 4-hourly precomputed snapshot; status and aging fields are
 * recalculated at request time so they are never stale. Onshore users only —
 * the report spans all consignments, including onshore-only documents.
 */
export const downloadMedistreamTrackingReportCsvMedistreamTrackingReportGet = <ThrowOnError extends boolean = false>(options?: Options<DownloadMedistreamTrackingReportCsvMedistreamTrackingReportGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<DownloadMedistreamTrackingReportCsvMedistreamTrackingReportGetResponses, DownloadMedistreamTrackingReportCsvMedistreamTrackingReportGetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/medistream-tracking/report',
        ...options
    });
};

/**
 * Medistream Tracking Report Summary
 */
export const medistreamTrackingReportSummaryMedistreamTrackingReportSummaryGet = <ThrowOnError extends boolean = false>(options?: Options<MedistreamTrackingReportSummaryMedistreamTrackingReportSummaryGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<MedistreamTrackingReportSummaryMedistreamTrackingReportSummaryGetResponses, MedistreamTrackingReportSummaryMedistreamTrackingReportSummaryGetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/medistream-tracking/report/summary',
        ...options
    });
};

/**
 * Refresh Medistream Tracking Report
 * Trigger an out-of-band snapshot rebuild. Returns immediately.
 */
export const refreshMedistreamTrackingReportMedistreamTrackingReportRefreshPost = <ThrowOnError extends boolean = false>(options?: Options<RefreshMedistreamTrackingReportMedistreamTrackingReportRefreshPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<RefreshMedistreamTrackingReportMedistreamTrackingReportRefreshPostResponses, RefreshMedistreamTrackingReportMedistreamTrackingReportRefreshPostErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/medistream-tracking/report/refresh',
        ...options
    });
};

/**
 * List Documents With Agent Runs
 */
export const listDocumentsWithAgentRunsDocumentAgentRunsGet = <ThrowOnError extends boolean = false>(options?: Options<ListDocumentsWithAgentRunsDocumentAgentRunsGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListDocumentsWithAgentRunsDocumentAgentRunsGetResponses, ListDocumentsWithAgentRunsDocumentAgentRunsGetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/document-agent/runs',
        ...options
    });
};

/**
 * List A Document'S Agent Runs
 */
export const listADocumentSAgentRunsDocumentAgentDocumentsKeyRunsGet = <ThrowOnError extends boolean = false>(options: Options<ListADocumentSAgentRunsDocumentAgentDocumentsKeyRunsGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ListADocumentSAgentRunsDocumentAgentDocumentsKeyRunsGetResponses, ListADocumentSAgentRunsDocumentAgentDocumentsKeyRunsGetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/document-agent/documents/{key}/runs',
        ...options
    });
};

/**
 * Get An Agent Run
 */
export const getAnAgentRunDocumentAgentDocumentsKeyRunsRunIdGet = <ThrowOnError extends boolean = false>(options: Options<GetAnAgentRunDocumentAgentDocumentsKeyRunsRunIdGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetAnAgentRunDocumentAgentDocumentsKeyRunsRunIdGetResponses, GetAnAgentRunDocumentAgentDocumentsKeyRunsRunIdGetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/document-agent/documents/{key}/runs/{run_id}',
        ...options
    });
};

/**
 * Get The Document Text The Agent Read
 */
export const getTheDocumentTextTheAgentReadDocumentAgentDocumentsKeyTextGet = <ThrowOnError extends boolean = false>(options: Options<GetTheDocumentTextTheAgentReadDocumentAgentDocumentsKeyTextGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetTheDocumentTextTheAgentReadDocumentAgentDocumentsKeyTextGetResponses, GetTheDocumentTextTheAgentReadDocumentAgentDocumentsKeyTextGetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/document-agent/documents/{key}/text',
        ...options
    });
};

/**
 * Get The Gold-Set Review Queue
 */
export const getTheGoldSetReviewQueueGoldSetQueueGet = <ThrowOnError extends boolean = false>(options?: Options<GetTheGoldSetReviewQueueGoldSetQueueGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetTheGoldSetReviewQueueGoldSetQueueGetResponses, GetTheGoldSetReviewQueueGoldSetQueueGetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/gold-set/queue',
        ...options
    });
};

/**
 * List The Gold-Set Categories
 */
export const listTheGoldSetCategoriesGoldSetCategoriesGet = <ThrowOnError extends boolean = false>(options?: Options<ListTheGoldSetCategoriesGoldSetCategoriesGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListTheGoldSetCategoriesGoldSetCategoriesGetResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/gold-set/categories',
        ...options
    });
};

/**
 * Get A Gold-Set Document
 */
export const getAGoldSetDocumentGoldSetDocumentsKeyGet = <ThrowOnError extends boolean = false>(options: Options<GetAGoldSetDocumentGoldSetDocumentsKeyGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetAGoldSetDocumentGoldSetDocumentsKeyGetResponses, GetAGoldSetDocumentGoldSetDocumentsKeyGetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/gold-set/documents/{key}',
        ...options
    });
};

/**
 * Save A Gold-Set Label
 */
export const saveAGoldSetLabelGoldSetDocumentsKeyLabelPut = <ThrowOnError extends boolean = false>(options: Options<SaveAGoldSetLabelGoldSetDocumentsKeyLabelPutData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<SaveAGoldSetLabelGoldSetDocumentsKeyLabelPutResponses, SaveAGoldSetLabelGoldSetDocumentsKeyLabelPutErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/gold-set/documents/{key}/label',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};